module.exports = __webpack_public_path__ + "static/media/9H.aa8ebbca.svg";